<template>
  <div class="app-layout flex w-full">
    <MainMenu v-model:expanded="menuExpanded" />
    <div class="flex flex-1 flex-col min-w-0 min-h-0">
      <TopToolbar />
      <main class="flex-1 min-h-0 overflow-auto pb-[env(safe-area-inset-bottom,0px)]">
        <div class="p-4">
          <slot />
        </div>
      </main>
    </div>
  </div>
</template>

<script setup lang="ts">
import MainMenu from './MainMenu.vue';
import TopToolbar from './TopToolbar.vue';
import { useMenuExpanded } from '@/composables/useMenuExpanded';

const menuExpanded = useMenuExpanded();
</script>
